import { BaseRecord } from 'app/context/data/types';
import { Descriptions } from 'app/modules/ui';
import React from 'react';
import { DESCRIPTION_DEF, DESCRIPTION_RESULT } from './config';
import { InspectionPOItem } from 'app/modules/inspection/types';
import groupBy from 'lodash/groupBy';
import { isNumber, isString } from 'lodash';
import classes from './Workmanship.module.scss';
import { Divider } from 'antd';

type WorkmanshipProps<T = BaseRecord> = {
  value: T;
  progress?: string;
  poItem: InspectionPOItem;
};

export const Workmanship = (props: WorkmanshipProps) => {
  const { value, progress, poItem } = props;
  const descriptionValue = React.useMemo(() => {
    return {
      ...value,
      progress
    };
  }, [value, progress]);

  const consolidatedDefects = React.useMemo(() => {
    const { defects } = descriptionValue as any;
    if (!defects) return [];
    const groupedByClassification = groupBy(
      defects.filter(({ quantity }) => {
        if (isNumber(quantity)) return quantity > 0;
        if (isString(quantity)) return Number(quantity) > 0;
        return !!quantity;
      }),
      'defectClassification'
    );
    return Object.entries(groupedByClassification).reduce(
      (acc, [, defects]) => {
        return [...acc, ...defects];
      },
      []
    );
  }, [descriptionValue]);

  return (
    <>
      <Descriptions
        className={classes.collapse}
        column={1}
        items={DESCRIPTION_DEF}
        value={descriptionValue}
        meta={{ poItem, defects: consolidatedDefects }}
      />
      <Divider style={{ marginTop: 16 }} />
      <Descriptions
        className={classes['collapse-result']}
        column={1}
        items={DESCRIPTION_RESULT}
        value={descriptionValue}
        meta={{ poItem, defects: consolidatedDefects }}
      />
    </>
  );
};
